module.exports = __webpack_public_path__ + "img/image_39.f7a83e73.png";